import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import CommentsItem from "./CommentsItem";
import AddComments from "./AddComments";
import { Empty } from "../BP2Components/Empty/Empty";
import { Button } from "../BP2Components";
import { Icon_Comment, Icon_ArrowBar } from "../BP2Components/Icons/icons";
import "./comments.less";

const Comments = ({
   buttons,
   currentProcessStep,
   isQuestionMode,
   sysBtnsConfig,
   commentsPosition,
   setCommentsPosition,
   commentsSizeClass,
   setCurrentProcessStep,
   scrollToFieldByTechname
}) => {
   const { comments } = useSelector(({ formsv2 }) => formsv2);
   const commentsFormRef = useRef(null);
   const intl = useIntl();
   const { isNavVisible } = useSelector(({ settings }) => settings);
   const setCommentsContainerStyles = (isNavVisible, commentsSizeClass) => {
      if (commentsSizeClass === "comments-full") {
         if (isNavVisible) {
            return { left: "280px" };
         } else {
            return { left: "80px" };
         }
      }
   };
   useEffect(() => {
      commentsFormRef.current?.scrollTo({
         top: commentsFormRef.current.scrollHeight,
         behavior: "smooth"
      });
   }, [comments?.length]);
   return (
      <div
         id="case-comments-container"
         className="comments-container"
         style={setCommentsContainerStyles(isNavVisible, commentsSizeClass)}
      >
         <div className="comments-header-fake"></div>
         <div className="comments-header">
            <span className="gx-pl-3 p1" style={{ width: "80%" }}>
               <span className="gx-pr-2" style={{ position: "relative", top: "2px" }}>
                  <Icon_Comment
                     fill="#2b559c"
                     stroke="none"
                     className="comment-icon"
                  ></Icon_Comment>
               </span>
               {intl.formatMessage({ id: "comments.activityStream" })}
            </span>
            <span className="header-right-container">
               <Button
                  buttonType="third"
                  style={{ width: 40 }}
                  onClick={() => setCommentsPosition(commentsPosition + 1)}
               >
                  <Icon_ArrowBar
                     fill={"#545454"}
                     stroke="none"
                     className={"arrow-bar-icon reverse-arrow-bar-icon"}
                  />
               </Button>
            </span>
         </div>
         <div className="comments-form" ref={commentsFormRef}>
            {comments && comments.length > 0 ? (
               comments.map((comment, key) => (
                  <CommentsItem
                     comment={comment}
                     key={key}
                     scrollToFieldByTechname={scrollToFieldByTechname}
                  />
               ))
            ) : (
               <Empty description={intl.formatMessage({ id: "comments.noComments" })} />
            )}
         </div>
         <AddComments
            buttons={buttons}
            currentProcessStep={currentProcessStep}
            isQuestionMode={isQuestionMode}
            sysBtnsConfig={sysBtnsConfig}
            setCurrentProcessStep={setCurrentProcessStep}
            actionsVisible={true}
         />
      </div>
   );
};

export default Comments;
